export default class BaseModal {
  constructor() {
    this.resolvePromise = null
  }

  modalId() {
    throw new Error("Subclasses must implement modalId()")
  }

  modalHTML() {
    throw new Error("Subclasses must implement modalHTML()")
  }

  bindEvents() {
    throw new Error("Subclasses must implement bindEvents()")
  }

  show() {
    return new Promise((resolve) => {
      this.resolvePromise = resolve
      this.insertModalIntoDOM()
      this.lockBodyScroll()
      this.bindEvents()
    })
  }

  dismiss() {
    this.removeModalFromDOM()
    this.unlockBodyScroll()
    this.resolvePromise()
  }

  modalElement() {
    return document.getElementById(this.modalId())
  }

  insertModalIntoDOM() {
    document.body.insertAdjacentHTML("beforeend", this.modalHTML())
  }

  removeModalFromDOM() {
    this.modalElement()?.remove()
  }

  lockBodyScroll() {
    document.body.style.overflow = "hidden"
  }

  unlockBodyScroll() {
    document.body.style.overflow = ""
  }
}
